(function () {
    const init = (imageBrowser) => {
        const ImageViewport = function (imageBrowser) {
            this.root = imageBrowser;
            this.imageData = 0;
            this.images = imageBrowser.querySelectorAll('[data-entry-images-browser-image-src]');
            this.imageZoom = imageBrowser.querySelector('[data-entry-images-browser-zoom]');
            this.init();
        };
        const fn = ImageViewport.prototype;
        fn.setSizes = function () {
            const o = this;
            const container = o.imageZoom.parentNode;
            const isLargeScreen = window.matchMedia("(min-width: 768px)").matches;
            const navigator = o.root.querySelector('[data-entry-images-browser-navigator]');

            if (isLargeScreen) {
                container.style.paddingBottom = 0;
                container.style.height = '100%';
                navigator.style.justifyContent = navigator.scrollHeight > o.root.offsetHeight ? 'flex-start' : 'center';
            } else {
                const box = {
                    width: container.parentNode.offsetWidth,
                    height: (window.innerHeight - 100) * (window.visualViewport.scale || 1)
                };
                const imageRatio = o.imageData.width / o.imageData.height;
                if (box.width / box.height < imageRatio) {
                    const w = Math.min(box.width, o.imageData.width);
                    container.style.paddingBottom = ((w / box.width) / imageRatio * 100) + '%';
                } else {
                    const h = Math.min(box.height, o.imageData.height);
                    container.style.paddingBottom = ((h / box.width) * 100) + '%';
                }
                container.style.height = 0;
                navigator.style.justifyContent = navigator.scrollWidth > o.root.offsetWidth ? 'flex-start' : 'center';
            }
        };
        fn.init = function () {
            const o = this;
            const viewer = o.root.querySelector('#entryImagesBrowserImageViewer');
            o.images.forEach((element, index) => {
                element.addEventListener('click', function (e) {
                    if (element.classList.contains('entryImagesBrowser__preview--current')) {
                        return false;
                    }
                    window.localStorage.setItem("ba" + window.location.href, index + '');
                    const current = o.root.querySelector('.entryImagesBrowser__preview--current[data-entry-images-browser-image-src]');
                    if (!!current) {
                        current.classList.remove('entryImagesBrowser__preview--current');
                    }
                    element.classList.add('entryImagesBrowser__preview--current');
                    o.imageData = {
                        src: element.getAttribute('data-entry-images-browser-image-src'),
                        lowSrc: element.getAttribute('data-entry-images-browser-image-low-src'),
                        width: element.getAttribute('data-entry-images-browser-image-natural-width'),
                        height: element.getAttribute('data-entry-images-browser-image-natural-height')
                    };
                    o.setSizes.call(o);
                    o.root.querySelector('[data-entry-images-browser-caption]').innerHTML = element.getAttribute('data-entry-images-browser-image-caption');
                    viewer.dispatchEvent(new CustomEvent('loadimage', {detail: o.imageData}));
                })
            });
            if (o.images.length > 0) {
                const toIndex = window.localStorage.getItem("ba" + window.location.href) || '0';
                o.images[parseInt(toIndex)].dispatchEvent(new Event('click'));
            }

            if (o.images.length === 1) {
                o.root.querySelector('[data-entry-images-browser-navigator]').parentNode.style.display = 'none';
            }

            const getWindowOrientation = () => {
                return window.matchMedia("(orientation:landscape)").matches ? 'landscape' : 'portrait';
            };

            let timeout = 0;
            let orientation = getWindowOrientation();
            window.addEventListener('resize', () => {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    const nextOrientation = getWindowOrientation();
                    if (orientation !== nextOrientation || !window.matchMedia("(pointer:coarse)").matches) {
                        orientation = nextOrientation;
                        o.setSizes.call(o);
                        viewer.dispatchEvent(new CustomEvent('resize', {}));
                    }
                }, 300);
            });
        };
        new ImageViewport(imageBrowser);
    };

    window.addEventListener('load', () => {
        setTimeout(() => {
            document.querySelectorAll('[data-entry-images-browser]').forEach(init);
        }, 10)

    });
})();
